import { cn } from "@/lib/utils";
import logoUrl from "@/assets/fedor-logo-240.webp";
import logoDarkUrl from "@/assets/fedor-logo-dark-240.webp";

interface LogoProps {
  className?: string;
}

/**
 * Official Fedor Timmerwerken logo — original charcoal + red version from the
 * brand EPS for the light theme, plus the off-white recolored variant for
 * dark mode. Both variants render side by side and CSS (dark:) shows exactly
 * one, so the swap is instant and hydration-safe.
 *
 * Beide varianten zijn 400×294: het logo wordt maximaal 64 px hoog getoond
 * (~87 px breed), dus 400 px dekt zelfs retina ruim. De oude 800×588-bestanden
 * waren ~5x groter dan nodig.
 *
 * De donkere variant staat op loading="lazy": in het lichte thema is die
 * display:none, waardoor browsers hem overslaan en er minder over de mobiele
 * verbinding gaat. In het donkere thema is hij zichtbaar en laadt hij meteen.
 */
export function Logo({ className }: LogoProps) {
  return (
    <>
      <img
        src={logoUrl}
        alt="Fedor Timmerwerken"
        width={240}
        height={176}
        decoding="async"
        className={cn(className, "dark:hidden")}
      />
      <img
        src={logoDarkUrl}
        alt=""
        aria-hidden="true"
        width={240}
        height={176}
        loading="lazy"
        decoding="async"
        className={cn(className, "hidden dark:block")}
      />
    </>
  );
}
